import moment, { Moment } from "moment";
import { DateFormats } from "../common/Constants";

export interface IDateService {
  formatDate(date: Date): string;
  formatTime(date: Date): string;
  formaDateWithTime(date: Date): string;
  parseDate(date: Date): Moment;
  parseDateToTimestamp(value: Date): number;
}

const DateService = (): IDateService => {
  return {
    formatDate(date: Date) {
      return moment(date).format(DateFormats.DATE);
    },

    formatTime(date: Date) {
      return moment(date).format(DateFormats.TIME);
    },

    formaDateWithTime(date: Date) {
      return moment(date).format(DateFormats.DATETIME_LOCAL);
    },

    parseDate(date: Date) {
      return moment(date, DateFormats.DATETIME_LOCAL);
    },

    parseDateToTimestamp(value: Date) {
      return +moment(value, DateFormats.DATETIME_LOCAL)
        .utc(true)
        .format("x");
    }
  };
};

export { DateService };
